import React from 'react';

// DEPENDENCIES
import clsx from 'clsx';
import identity from 'lodash/identity';

// GLOBAL FUNCTIONS
import { formatDateTime } from 'functions.js';

// PROTOTYPE
import Log from '../prototype/Log';

// LOCAL PARTS
import CommentForm from './commentsLog/CommentForm';

// STYLES
import styles from './commentsLog.module.scss';

// COMPONENTS
const CommentsLog = ({ dataProcessor = identity, ...props }) => (
  <Log
    label="comments"
    item={data => {
      const { body, createdBy, createdDate } = dataProcessor(data);
      return (
        <div className={clsx(
          'comment-item',
          styles.item
        )}>
          <div className={styles.body}>
            <p>{body}</p>
          </div>
          <div className={styles.footer}>
            <div className={styles.createdBy}>{createdBy}</div>
            <div className={styles.dateTime}>{formatDateTime(createdDate)}</div>
          </div>
        </div>
      )
    }}
    before={<CommentForm {...props} />}
    {...props}
  />
);
CommentsLog.Inventory = props => (
  <CommentsLog
    {...props}
  />
)

// EXPORT
export default CommentsLog;
